import React from 'react'

export default function About() {
  return (
    <div className='about' id ="about">
        <span className='title'>01. ABOUT ME</span>
        <div className='content'>
            <ul>
                <li>
                    <p>사용자의 경험(UI/UX)을 안정적인 로직(Back-end)으로 완성하는</p>
                    <h4>개발자, 김민주입니다.</h4>
                </li>
            </ul>
        </div>
    </div>
  )
}
